import { Component, Input } from '@angular/core';

import { FileHistoryItems } from 'src/app/interfaces/file.interface';
import { HistoryChangesTypes } from '../files-manager.helpers';

@Component({
  selector: 'app-file-history',
  templateUrl: './file-history.component.html',
  styleUrls: ['./file-history.component.scss'],
})
export class FileHistoryComponent {
  @Input({ required: true }) public fileHistory: FileHistoryItems[];

  public downloadsCountCalc(): number {
    return this.calculateEvents(HistoryChangesTypes.downloaded);
  }

  public viewsCountCalc(): number {
    return this.calculateEvents(HistoryChangesTypes.viewed);
  }

  private calculateEvents(event: HistoryChangesTypes): number {
    if (this.fileHistory) {
      return this.fileHistory.reduce((sum: number, current: FileHistoryItems) => {
        return current.event_type === event ? sum + 1 : sum;
      }, 0);
    }
    return 0;
  }
}
